export function getCartItems() {
    var loadData = localStorage.getItem("cartProducts");
    if (loadData) {
        var savedProducts = JSON.parse(loadData);
        return savedProducts;
    }
    return null;
}
export function postCartItems(products) {
    localStorage.setItem("cartProducts", JSON.stringify(products));
}
export function removeAllCartItems() {
    localStorage.removeItem("cartProducts");
}
